import { render, staticRenderFns } from "./mingfang.vue?vue&type=template&id=25be58e5&scoped=true&"
import script from "./mingfang.vue?vue&type=script&lang=js&"
export * from "./mingfang.vue?vue&type=script&lang=js&"
import style0 from "./mingfang.vue?vue&type=style&index=0&id=25be58e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25be58e5",
  null
  
)

export default component.exports